<template>
  <div>
    <carousel
      :scrollPerPage="true"
      :perPageCustom="[
        [480, 2],
        [768, 3],
        [992, 4],
        [1140, 5]
      ]"
      :paginationSize="20"
      :autoplay="true"
      :loop="true"
    >
      <slide v-for="(aggregator, id) in aggregators" :key="id">
        <div class="mb-3 mx-2 text-center">
          <router-link class="d-block mb-3" :to="'/aggregator/' + aggregator">
            <img
              :src="'/assets/images/aggregator/' + aggregator + '.png'"
              class="img-fluid border border-rounded rounded-lg"
              style="height: 270px; width:inheit;"
            />
            <h6 class="text-black font-weight-bold">
              {{ aggregator | capitalize }}
              <span v-if="aggregator == 'logistics'">Partner</span>
              <span v-if="aggregator == 'input' || aggregator == 'warehouse'">
                Provider
              </span>
            </h6>
          </router-link>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    Carousel,
    Slide
  },
  data() {
    return {
      aggregators: [
        "aggregator",
        "farmer",
        "trader",
        "input",
        "logistics",
        "warehouse",
        "processor"
      ]
    };
  }
};
</script>
